/* eslint-disable no-alert */
import React from 'react';
import _ from 'lodash';
import { CircularProgress, Stack, Card, CardHeader, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, Modal, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { formatDateTime } from '../../../../../../services/functions';
import { updateOrder } from '../../../../../../services/redux-actions';
import { fineAndSendMailInfo } from '../../../../../../services/request';
import { useParameterizedQuery } from 'react-fetching-library';
import { SnackbarAlert } from '../../../../../../components-core/SnackbarAlert';
import { PAYMENT_DIALOG_STYLE } from '../../../../../../utils/consts';

import { AlertDialogContainer } from '../../../../../../components-core/others/AlertDialogContainer';

import AddPaymentModal from '../OrderTab/AddPaymentModal';
import { getRodzajPlatnosciString } from '../OrderTab/CreatePayment';


const PaymentSummary = () => {
  const dispatch = useDispatch();
  const { order } = useSelector(state => state.app);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('success');
  const [title, setTitle] = React.useState('Wysłano maila');
  const [message, setMessage] = React.useState('');
  const { query: fineAndSendMailInfoQuery, loading: fineLoading } = useParameterizedQuery(fineAndSendMailInfo);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  const fineAndSendMailClick = async payments => {
    if (order.order_payments !== undefined && order.order_payments.filter(unpaidFilter).length <= 0) {
      return;
    }
    const first = order.order_payments[0];
    const { error, payload } = await fineAndSendMailInfoQuery(first.id);
    console.log(payload);
    if (!error) {
      // alert(`Mail o następującej treście został wysłany:\n ${payload.messageSent}`);
      setMessage(`Mail o następującej treście został wysłany:\n ${payload.messageSent}`);
      const updatedOrder = { ...order, order_payments: [payload.payment_added, ...order.order_payments] };
      dispatch(updateOrder(updatedOrder));
      setShowAlert(true);
    } else {
      alert('nie udało się wysłać maili');
    }
  };

  const unpaidFilter = item => !item.paid && !item.deleted;

  const toPay = order.order_payments.filter(unpaidFilter).map(item => item.to_pay)
    .reduce((prev, next) => prev + next, 0);

  const paid = order.order_payments.filter(item => item.paid).map(item => item.to_pay)
    .reduce((prev, next) => prev + next, 0);

  return (
    <>
      {showAlert && (
        <AlertDialogContainer
          severity={severity}
          title={title}
          message={message}
          setShowAlert={setShowAlert}
        />
      )}
      <Stack direction="row" spacing={2} sx={{ m: 2 }}>
        <TableContainer component={Card} sx={{ minHeight: '200px' }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row">
              <CardHeader title="Do zapłaty" sx={{ mb: 1, mt: -1 }} />
              <Button variant="contained" sx={{ mb: 1, mt: 1 }} disabled={fineLoading || order.order_payments.filter(unpaidFilter).length <= 0 } onClick={() => fineAndSendMailClick()}>Dodaj potrącenie i wyślij info.{fineLoading ? <CircularProgress size={12} /> : null}</Button>
            </Stack>
            {toPay === 0 ? null : <Typography sx={{ pr: 3 }} variant="subtitle2" color="#ea0e0e">-{toPay}zł</Typography>}
          </Stack>
          <Table aria-label="spanning table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Cena (zł)</TableCell>
                <TableCell align="center">Nazwa</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {order.order_payments.filter(unpaidFilter).map(row => (
                <TableRow key={row.id}>
                  <TableCell align="center">{row.to_pay}</TableCell>
                  <TableCell align="center">{getRodzajPlatnosciString(row)}{row.title}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer component={Card} sx={{ minHeight: '200px' }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row">
              <CardHeader title="Zapłacone" sx={{ mb: 1, mt: -1 }} />
              <Button variant="contained" sx={{ mb: 1, mt: 1 }} onClick={() => setOpenModal(true)}>Dodaj płatność</Button>
            </Stack>
            {paid === 0 ? null : <Typography sx={{ pr: 3 }} variant="subtitle2" color="#208a20">+{paid}zł</Typography>}
          </Stack>
          <Table aria-label="spanning table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Data</TableCell>
                <TableCell align="center">Cena (zł)</TableCell>
                <TableCell align="center">Nazwa</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {order.order_payments.filter(item => item.paid).map(row => (
                <TableRow key={row.id}>
                  <TableCell align="center">{formatDateTime(row.created_at)}</TableCell>
                  <TableCell align="center">{row.to_pay}</TableCell>
                  <TableCell align="center">{getRodzajPlatnosciString(row)}{row.title}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
        >
          <Card sx={{ ...PAYMENT_DIALOG_STYLE, width: '500px' }}>
            <CardHeader title="Dodaj płatność" />
            <CardContent>
              <AddPaymentModal order={order} handleClose={() => setOpenModal(false)}/>
            </CardContent>
          </Card>
        </Modal>
      </Stack>
      <SnackbarAlert open={openSnackbar} severity="error" message="Nie udało się pobrać pliku" onClose={handleCloseSnackbar} />
    </>
  );
};


export default PaymentSummary;
